import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { icons } from '../../../assets/icons';
import './index.scss';
import useOnclickOutside from 'react-cool-onclickoutside';
import { useDispatch, useSelector } from 'react-redux';
import { userBlocked, usersList_admin } from '../../../api/redux/slices/Admin';
import { toast } from 'react-toastify';
import { CSVLink } from 'react-csv';
import { LoaderComponent } from '../../../helpers/components/loader';
import Pagination from '../../../helpers/components/Pagination';
import useCSVExport from './csvExport';
import useStableArr from '../../../utils/useStableArr';
import { handleCheck, handleCheckAll } from '../../../utils/checkUtilsAdmin';
import { convertCategory, convertRegulation } from '../../../helpers/modules';

const ClientListPage = () => {
	const { list, checkedList, total } = useSelector((state) => state.admin);

	const [openDropdown, setOpenDropdown] = useState(false);
	const [indice, setIndice] = useState(null);
	const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 }); // ✅ position du dropdown
	const [userName, setUserName] = useState('');
	const [regulationName, setRegulationName] = useState('');
	const [categoriesName, setCategoriesName] = useState('');
	const [typing, setTyping] = useState(false);
	const [newArr, setNewArr] = useState(list.map((el) => ({ ...el, checked: false })));
	const [isCheck, setIsCheck] = useState(false);
	const params = useParams();
	const dispatch = useDispatch();
	const [page, setPage] = useState(Number(params.page));
	const token = localStorage.getItem('accesstoken');
	const csvUsersReport = useCSVExport(checkedList);

	const ref = useOnclickOutside(() => {
		setOpenDropdown(false);
	});

	const [isloading, setIsLoading] = useState(false);

	const stableDispatch = useCallback(() => {
		setIsLoading(true);
		dispatch(
			usersList_admin({
				token: token,
				name: userName,
				categories: categoriesName,
				regulation: regulationName,
				page: userName || categoriesName || regulationName ? undefined : page,
			}),
		)
			.unwrap()
			.finally(() => setIsLoading(false));
	}, [dispatch, userName, categoriesName, regulationName, page, token]);

	useEffect(() => {
		if (token) {
			stableDispatch();
		}
	}, [stableDispatch, token]);

	useStableArr(list, checkedList, setNewArr, setIsCheck);

	// ✅ Fermer le dropdown au scroll pour éviter le décalage
	useEffect(() => {
		const handleScroll = () => setOpenDropdown(false);
		window.addEventListener('scroll', handleScroll, true);
		return () => window.removeEventListener('scroll', handleScroll, true);
	}, []);

	// ✅ Calculer la position exacte du bouton cliqué
	const handleToggleDropdown = (e, id) => {
		const rect = e.currentTarget.getBoundingClientRect();
		if (openDropdown && indice === id) {
			setOpenDropdown(false);
		} else {
			setDropdownPos({
				top: rect.bottom + 4,       // juste en dessous du bouton
				left: rect.left - 160,      // décalé à gauche pour ne pas sortir de l'écran
			});
			setOpenDropdown(true);
			setIndice(id);
		}
	};

	const handleBlock = (e, id) => {
		e.preventDefault();
		const data = { is_active: false };
		dispatch(userBlocked({ token: token, id: id, data: data }))
			.unwrap()
			.then(() => {
				setOpenDropdown(false);
				toast.info('Utilisateur bloqué', { position: 'bottom-right', autoClose: 2000 });
				dispatch(usersList_admin({ token: token, name: userName, categories: categoriesName, regulation: regulationName, page: page }));
			})
			.catch((err) => { toast.error(err, { position: 'bottom-right', autoClose: 2000 }); });
	};

	const handleUnblock = (e, id) => {
		e.preventDefault();
		const data = { is_active: true };
		dispatch(userBlocked({ token: token, id: id, data: data }))
			.unwrap()
			.then(() => {
				setOpenDropdown(false);
				toast.info('Utilisateur débloqué', { position: 'bottom-right', autoClose: 2000 });
				dispatch(usersList_admin({ token: token, name: userName, categories: categoriesName, regulation: regulationName, page: page }));
			})
			.catch((err) => { toast.warn(err, { position: 'bottom-right', autoClose: 2000 }); });
	};

	return (
		<div id='clientListPageAdmin'>
			<div className='navbar'>
				<div className='left'>
					<div className='nav-search'>
						<input
							type='text'
							placeholder='Rechercher ...'
							value={userName}
							onChange={(e) => { setUserName(e.target.value); setTyping(true); }}
						/>
						<icons.FiSearch className='searchicon' />
						{typing && (
							<icons.GrFormClose className='searchicon' onClick={() => { setUserName(''); setTyping(false); }} />
						)}
					</div>
					<div className='filters'>
						<select value={categoriesName} onChange={(e) => setCategoriesName(e.target.value)}>
							<option value=''>Catégories</option>
							<option value='grossiste'>Grossiste</option>
							<option value='detaillant'>Detaillant</option>
							<option value='monoprix'>Grande surface</option>
						</select>
					</div>
					<div className='filters'>
						<select value={regulationName} onChange={(e) => setRegulationName(e.target.value)}>
							<option value=''>Régléments</option>
							<option value='cheque'>Chèque</option>
							<option value='espece'>Espèce</option>
							<option value='traite'>Traité</option>
						</select>
					</div>
				</div>
				<div className='right'>
					<div className='right-items'>
						<Link to={`/admin/users/add_user/${page}`}>
							<button className='button-primary'><icons.SiAddthis /><span>Utilisateur</span></button>
						</Link>
						<button className='button-nature' title='exporter utilisateur'>
							<CSVLink {...csvUsersReport} target='blank'><icons.BiExport /></CSVLink>
						</button>
					</div>
				</div>
			</div>

			<div id='head'>
				<div className='title-user'><h1>Liste des clients</h1></div>
			</div>

			<div className='usersContents'>
				<table id='users'>
					<thead>
						<tr id='titres'>
							<td className='input-check'>
								<input type='checkbox' className='checkbox' checked={isCheck} onChange={() => handleCheckAll(dispatch, newArr, setNewArr, isCheck, setIsCheck)} />
							</td>
							<td>CLIENT</td>
							<td>SOCIÉTÉ</td>
							<td>MATRICULE FISCALE</td>
							<td style={{ margin: 'auto' }}>CATÉGORIE</td>
							<td style={{ margin: 'auto' }}>REGLEMENT</td>
							<td style={{ margin: 'auto' }}>STATUT</td>
							<td>ACTION</td>
						</tr>
					</thead>
					<tbody>
						{isloading ? (
							<tr><td colSpan='8'><LoaderComponent margin='10%' /></td></tr>
						) : newArr?.length > 0 ? (
							newArr.map((u, index) => (
								<tr id={`element-${index}`} className='user' key={u._id}>
									<td className='input-check'>
										<input type='checkbox' className='checkbox' checked={u.checked} onChange={() => handleCheck(dispatch, newArr, setNewArr, u._id)} />
									</td>
									<td>{u.first_name} {u.last_name}</td>
									<td>{u.company_name ? u.company_name : '-'}</td>
									<td>{u.tax_registration_number}</td>
									<td style={{ margin: 'auto' }}>{u.categories && u.role === 'customer' ? convertCategory(u.categories) : '-'}</td>
									<td style={{ margin: 'auto' }}>{u.regulation && u.role === 'customer' ? convertRegulation(u.regulation) : '-'}</td>
									<td style={{ margin: 'auto' }} className={u.is_active === true ? 'user-status' : 'user-status activé'}>
										{u.is_active === true ? 'Activé' : 'Bloqué'}
									</td>
									<td className='last-user-element'>
										<Link to={`/admin/users/user_details/${page}/${u._id}`} className='link-user'>
											<icons.BsEye className='see-user' />
										</Link>
										<div className='contain'>
											{/* ✅ handleToggleDropdown remplace l'ancien onClick */}
											<icons.BsThreeDotsVertical
												onClick={(e) => handleToggleDropdown(e, u._id)}
												className='user-option'
											/>
											{/* ✅ Le dropdown est rendu ici mais positionné en fixed via style inline */}
											{openDropdown && indice === u._id && (
												<div
													className='modalSelectOpt'
													ref={ref}
													style={{
														position: 'fixed',
														top: `${dropdownPos.top}px`,
														left: `${dropdownPos.left}px`,
														zIndex: 99999,
													}}
												>
													<ul>
														{u.is_active ? (
															<li onClick={(e) => { handleBlock(e, u._id); }}>Bloqué utilisateur</li>
														) : (
															<li onClick={(e) => { handleUnblock(e, u._id); }}>Débloquer utilisateur</li>
														)}
														<Link to={`/admin/users/update_user/${page}/${u._id}`}>
															<li>Modifier utilisateur</li>
														</Link>
													</ul>
												</div>
											)}
										</div>
									</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan='8' style={{ textAlign: 'center', padding: '50px' }}>
									Aucun client trouvé
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>

			<Pagination page={page} setPage={setPage} pageLink={`/admin/users/`} total={total} />
		</div>
	);
};

export default ClientListPage;